export default "__VITE_ASSET__uL3T9quH__"